<template>
  <section>
    <h2 class="flex items-center gap-3 text-sm text-gray-600 tablet:text-base">
      <span class="shrink-0">{{ title }}</span>
      <span class="h-px flex-1 bg-gray-500" aria-hidden="true" />
    </h2>
    <div class="mt-5 tablet:mt-6">
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
  defineProps<{ title: string }>();
</script>
